import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { reset_password, send_otp, sign_up, verify_otp_reset } from '../services';
import AuthLayout, { trackPointer, Field, AlertCircleIcon, CheckCircleIcon, ArrowRightIcon, ArrowLeftIcon, LockIcon, EyeButton } from './AuthLayout';
function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

function ValidateOtp() {
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const [isVerify, setVerify] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({ password: '', confirm: '' });
    const [strength, setStrength] = useState(0);
    const [responseMsg, setResponseMsg] = useState('');
    const [resMsg, setResMsg] = useState('');
    const [errResMsg, setErrResMsg] = useState('');
    const [isResetFlow, setIsResetFlow] = useState(false);
    const [emailId, setEmailId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false);
    const [showResend, setShowResend] = useState(true);
    const [timer, setTimer] = useState(30);
    const [getUserDataEmail, setGetUserDataEmail] = useState();
    const location = useLocation();

    useEffect(() => {
        let prevPath = location.pathname;
        const handler = () => {
            const currentPath = window.location.pathname;
            if (prevPath.includes("/otp-verification") && currentPath.includes("/sign-up")) {
                alert(
                    "CONFIRM FORM RESUBMISSION \n\n" +
                    "The page that you're looking for used information that you entered. " +
                    "Returning to that page might cause any action you took to be repeated.\n\n"
                );
            }
            prevPath = currentPath;
        };
        window.addEventListener("popstate", handler);
        return () => { window.removeEventListener("popstate", handler); };
    }, [location]);

    const validateOtp = () => {
        if (!otp.trim()) { setOtpError('OTP is required'); setIsLoading(false); return false; }
        setOtpError('');
        return true;
    };

    const validatePassword = () => {
        let passwordError = '';
        let confirmError = '';
        const passwordRegex = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()]).*$/;
        if (!password) { passwordError = 'Password is required'; setIsLoading(false); }
        else if (!passwordRegex.test(password)) { passwordError = 'Password must be 8+ chars with uppercase, lowercase, number & special char'; setIsLoading(false); }
        if (!confirmPassword) { confirmError = 'Please confirm your password'; setIsLoading(false); }
        else if (confirmPassword !== password) { confirmError = 'Passwords do not match'; setIsLoading(false); }
        setErrors({ password: passwordError, confirm: confirmError });
        return !passwordError && !confirmError;
    };

    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        const setters = { password: setPassword, confirmPassword: setConfirmPassword };
        if (setters[name]) { setters[name](value); setErrResMsg(''); }
        if (name === 'password') { setStrength(calculateStrength(value)); setErrResMsg(''); }
    };

    const calculateStrength = (password) => {
        let strength = 0;
        if (password.length >= 10) strength++;
        if (/[a-z]/.test(password)) strength++;
        if (/[A-Z]/.test(password)) strength++;
        if (/\d/.test(password)) strength++;
        if (/[!@#$%^&*()]/.test(password)) strength++;
        return Math.min(strength, 4);
    };

    useEffect(() => {
        const stateEmail = location.state?.email;
        const stateIsReset = location.state?.isReset;
        const email = stateEmail || sessionStorage.getItem('otp_email') || '';
        const resetFlag = stateIsReset !== undefined
            ? String(stateIsReset) === 'true'
            : sessionStorage.getItem('is_reset') === 'true';
        if (stateEmail) sessionStorage.setItem('otp_email', stateEmail);
        if (stateIsReset !== undefined) sessionStorage.setItem('is_reset', String(stateIsReset));
        setEmailId(email);
        setIsResetFlow(resetFlag);
    }, [location.state]);

    useEffect(() => {
        const getUserEmail = JSON.parse(localStorage.getItem('user_data') || '{}');
        setGetUserDataEmail(getUserEmail?.emailId);
    }, []);

    useEffect(() => {
        let interval;
        if (showResend && timer > 0) {
            interval = window.setInterval(() => { setTimer((prev) => prev - 1); }, 1000);
        } else if (timer === 0) {
            setShowResend(false);
        }
        return () => { if (interval) clearInterval(interval); };
    }, [showResend, timer]);

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!validateOtp()) { setIsLoading(false); return; }
        try {
            if (!isResetFlow) {
                const rawData = JSON.parse(localStorage.getItem("user_data") || "{}");
                const payload = { ...rawData, otp_code: otp };
                const response = await sign_up(payload);
                const successData = response?.statusCode?.response_data;
                const errorMessage = response?.statusCode?.error?.message;
                if (successData?.message) {
                    const { message } = successData;
                    setResponseMsg(message);
                    localStorage.removeItem("user_data");
                    localStorage.removeItem("step");
                    navigate("/");
                } else if (errorMessage) {
                    setErrResMsg(errorMessage);
                    setResponseMsg("");
                }
            } else {
                const payload = {
                    emailId: emailId,
                    otp_type: isResetFlow ? 'PASSWORD_RESET' : 'EMAIL_VERIFICATION',
                    otp_code: otp,
                };
                const response = await verify_otp_reset(payload);
                const successMessage = response?.statusCode?.response_data?.message;
                const errorMessage = response?.errors?.message;
                if (successMessage) {
                    setResponseMsg(successMessage);
                    setErrResMsg("");
                    setShowResend(true);
                    sessionStorage.removeItem("is_reset");
                    setIsResetFlow(false);
                    setVerify(true);
                } else if (errorMessage) {
                    setErrResMsg(errorMessage);
                    setResponseMsg("");
                }
            }
        } catch (err) {
            console.error("OTP submission failed:", err);
            setErrResMsg("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (validatePassword()) {
            try {
                const query = { emailId: emailId, password: password, confirm_password: confirmPassword };
                const response = await reset_password(query);
                setIsLoading(false);
                const successMessage = response?.statusCode?.response_data?.data?.message;
                const errorMessage = response?.errors?.message;
                if (successMessage) {
                    setResMsg(successMessage);
                    setErrResMsg('');
                    sessionStorage.removeItem('otp_email');
                    sessionStorage.removeItem('is_reset');
                    navigate('/');
                } else if (errorMessage) {
                    setErrResMsg(errorMessage);
                    setResMsg('');
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const resendOtp = async () => {
        setIsLoading(true);
        setShowResend(false);
        setTimer(30);
        const rawData = JSON.parse(localStorage.getItem('user_data') || '{}');
        try {
            const payload = {
                emailId: rawData.emailId || emailId,
                otp_type: isResetFlow ? 'PASSWORD_RESET' : 'EMAIL_VERIFICATION',
                otp_code: otp,
                phone_number: rawData.phone_number,
                country_code: rawData.country_code
            };
            const response = await send_otp(payload);
            setIsLoading(false);
            const successMessage = response?.statusCode?.response_data?.message;
            const errorMessage = response?.errors?.message;
            if (successMessage) {
                setResponseMsg(successMessage);
                setErrResMsg('');
                setShowResend(true);
            } else if (errorMessage) {
                setErrResMsg(errorMessage);
                setResponseMsg('');
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            setErrResMsg("Failed to resend OTP. Please try again.");
            setIsLoading(false);
        }
    };


    if (!isVerify) {
        return (
            <AuthLayout>
                <AuthLayout.Stage/>
                <AuthLayout.Panel>
                <div className="lg-wrap">
                    <header className="lg-form-header">
                        <p className="lg-eyebrow"><ShieldIcon/> Verify identity</p>
                        <h1 className="lg-title" id="lg-otp-title">OTP verification</h1>
                        <p className="lg-lead">
                            Enter the 6-digit code sent to{' '}
                            <strong className="lg-otp-email">
                                {isResetFlow ? emailId : (getUserDataEmail || emailId)}
                            </strong>
                        </p>
                    </header>

                    {responseMsg && (
                        <div className="lg-alert lg-alert--success" role="status">
                            <CheckCircleIcon/> <span>{responseMsg}</span>
                        </div>
                    )}
                    {errResMsg && (
                        <div className="lg-alert lg-alert--error" role="alert">
                            <AlertCircleIcon/> <span>{errResMsg}</span>
                        </div>
                    )}

                    <form className="lg-form" onSubmit={handleOtpSubmit} noValidate>
                        <div className="lg-otp-wrap">
                            <OtpInput
                                value={otp}
                                onChange={(value) => { setOtp(value); setOtpError(''); }}
                                numInputs={6}
                                renderSeparator={<span className="lg-otp-sep"/>}
                                renderInput={(props) => <input {...props}/>}
                                inputStyle={{
                                    width: '52px', height: '58px', fontSize: '22px', fontWeight: '600',
                                    textAlign: 'center', border: '1px solid rgba(10,10,10,.1)',
                                    borderRadius: '12px', background: '#fff', color: '#1d1d1d',
                                    outline: 'none', boxShadow: '0 1px 2px rgba(10,10,10,.04)',
                                    transition: 'border-color .3s, box-shadow .4s', fontFamily: 'inherit',
                                }}
                            />
                            {otpError && (
                                <p className="lg-field-error" role="alert">
                                    <AlertCircleIcon/> {otpError}
                                </p>
                            )}
                        </div>

                        <div className="lg-otp-resend">
                            {showResend ? (
                                <span>Resend OTP in {timer}s</span>
                            ) : isLoading ? (
                                <span>Sending OTP...</span>
                            ) : (
                                <button type="button" className="lg-link" onClick={resendOtp}>Resend OTP</button>
                            )}
                        </div>

                        <button type="submit" className="lg-submit lg-spot"
                            disabled={isLoading} aria-busy={isLoading} onPointerMove={trackPointer}>
                            {isLoading ? (
                                <span className="lg-submit-label"><span className="lg-spin" aria-hidden="true"/> Verifying...</span>
                            ) : (
                                <span className="lg-submit-label">Verify <ArrowRightIcon/></span>
                            )}
                            {isLoading && <i className="lg-scan" aria-hidden="true"/>}
                        </button>
                    </form>

                    <p className="lg-signup">
                        <button type="button" className="lg-back-btn" onClick={() => navigate('/')}>
                            <ArrowLeftIcon/> Back to login
                        </button>
                    </p>
                </div>

                <p className="lg-trust">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                    Your code expires in 10 minutes for security.
                </p>
                </AuthLayout.Panel>
            </AuthLayout>
        );
    }

    return (
        <AuthLayout>
            <AuthLayout.Stage/>
            <AuthLayout.Panel>
            <div className="lg-wrap">
                <header className="lg-form-header">
                    <p className="lg-eyebrow"><LockIcon/> Set new password</p>
                    <h1 className="lg-title" id="lg-pw-title">Create a new password</h1>
                    <p className="lg-lead">Choose a strong password to secure your account.</p>
                </header>

                {resMsg && (
                    <div className="lg-alert lg-alert--success" role="status">
                        <CheckCircleIcon/> <span>{resMsg}</span>
                    </div>
                )}
                {errResMsg && (
                    <div className="lg-alert lg-alert--error" role="alert">
                        <AlertCircleIcon/> <span>{errResMsg}</span>
                    </div>
                )}

                <form className="lg-form" onSubmit={handlePasswordSubmit} noValidate>
                    <Field name="password" type={showPass ? 'text' : 'password'} label="New password" icon={<LockIcon/>}
                        value={password} onChange={onChangeHandler} error={errors.password}
                        trailing={<EyeButton visible={showPass} onToggle={() => setShowPass(s => !s)}/>}/>

                    <div className="lg-strength-wrap" data-s={strength}>
                        <div className="lg-strength" data-s={strength}>
                            {Array.from({ length: 4 }).map((_, idx) => (
                                <div key={idx} className={`lg-str-bar${idx < strength ? ' lg-str-bar--on' : ''}`}/>
                            ))}
                        </div>
                        <span className="lg-strength-label">
                            {['', 'Weak', 'Fair', 'Good', 'Strong'][strength] || ''}
                        </span>
                    </div>

                    <Field name="confirmPassword" type={showConfirmPass ? 'text' : 'password'} label="Confirm new password" icon={<LockIcon/>}
                        value={confirmPassword} onChange={onChangeHandler} error={errors.confirm}
                        trailing={<EyeButton visible={showConfirmPass} onToggle={() => setShowConfirmPass(s => !s)}/>}/>

                    <button type="submit" className="lg-submit lg-spot"
                        disabled={isLoading} aria-busy={isLoading} onPointerMove={trackPointer}>
                        {isLoading ? (
                            <span className="lg-submit-label"><span className="lg-spin" aria-hidden="true"/> Resetting...</span>
                        ) : (
                            <span className="lg-submit-label">Reset password <ArrowRightIcon/></span>
                        )}
                        {isLoading && <i className="lg-scan" aria-hidden="true"/>}
                    </button>
                </form>

                <p className="lg-signup">
                    <button type="button" className="lg-back-btn" onClick={() => navigate('/')}>
                        <ArrowLeftIcon/> Back to login
                    </button>
                </p>
            </div>

            <p className="lg-trust">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="4.5" y="10.5" width="15" height="10" rx="3"/>
                    <path d="M8 10.5V8a4 4 0 018 0v2.5"/>
                </svg>
                Your account is protected with industry-standard encryption.
            </p>
            </AuthLayout.Panel>
        </AuthLayout>
    );
}

export default ValidateOtp;
